<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      title="PTV"
      id="ptvModel"
      :close="close"
      ref="ptvModel"
    >
      <template slot="head">
        <div class="head-operate">
          <!-- <el-button type="primary" @click="showPTV">
            <i class="el-icon-zengjia"></i> 导入数据
          </el-button> -->
          <!-- <el-upload
            action=""
            res="upload"
            :http-request="httpRequest"
            :before-upload="beforeUpload"
            multiple
            :show-file-list="false"
            accept=".json"
          >
            <el-button size="small" type="primary" class="upbtn"
              ><i class="el-icon-zengjia"></i> 上传</el-button
            >
            <div slot="tip" class="el-upload__tip">
              只能上传Json文件
            </div>
          </el-upload> -->
          <!-- <el-button type="primary" @click="showPTV">
            <i class="el-icon-zengjia"></i> CE
          </el-button> -->
        </div>
      </template>
      <!-- <template slot="foot">
        <div class="foot-operate">
          <el-button v-if="selectedScene" type="primary" @click="verification">
            加入场景
          </el-button>
        </div>
      </template> -->
    </MapModal>
  </div>
</template>
<script>
//按需加载
import axios from "axios";
import {
  getTreeNodeList,
  getProjectBimModel,
  deleteTdeeeiorst,
} from "@/api/api";
const MapModal = () => import("@/components/common/mapModal/Index");
// import * as ptvData from "@/components/tables/ptv/json/ptv.js";
import ptvData from "@/components/tables/ptv/json/ptv.json";
import * as mapWork from "./map.js";
export default {
  name: "ptv",
  components: { MapModal },
  props: ["close"],
  data() {
    return {
      show: false,
      checkedIds: [], //页面加载时默认勾选的id
      data: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      modalNode: {
        ptv: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -416,
            // unit: "px", // 默认px
          },
          width: "380px", // 宽度配置 默认450px
          height: `${document.querySelector("#mars3d-container").offsetHeight -
            140}px`, // 配置模态框中心高度
          // height: "350px",
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "modalTree", // id和ref使用的同一个
            name: "text", // 树的展示字段 默认name
            expand: false,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [
              {
                id: 1,
                text: "PTV模拟",
                operate: [
                  //操作按钮
                  {
                    i_icon: "small-operation-btn el-icon-video-play",
                    click: this.showPTV,
                  },
                ],
              },
              // {
              //   id: 1,
              //   text: "PTV模拟2",
              //   operate: [
              //     //操作按钮
              //     {
              //       i_icon: "small-operation-btn el-icon-video-play",
              //       click: this.showPTV2,
              //     },
              //   ],
              // },
            ],
            expandClick: true,
            i_icon: {
              level_1: "fa fa-car",
              level_2: "las la-map-marker",
            },
            search: {
              keywords: "text", // 搜素配置关键字 默认是name
            },
            // checkBox: true,
            // check: this.checkBoxClick,
            nodeClick: this.nodeClick,
          },
        },
      },
    };
  },
  computed() {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    httpRequest(item) {
      let formData = new FormData();
      formData.append("file", item.file);
      // axios
      //   .post("/baseIP/BimModelExcavationDetails/addKml", formData, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //       Authorization: "Bearer " + window.sessionStorage.getItem("token"),
      //       "X-Authorization":
      //         "Bearer " + window.sessionStorage.getItem("refreshToken"),
      //     },
      //   })
      //   .then((res) => {
      //     this.$notify({
      //       title: "上传成功",
      //       message: "",
      //       type: "success",
      //       duration: 960,
      //       offset: 320,
      //     });
      //   })
      //   .catch(function(err) {
      //     this.$notify({
      //       title: "上传失败",
      //       message: "",
      //       type: "error",
      //       duration: 960,
      //       offset: 320,
      //     });
      //   });
    },
    beforeUpload() {},
    nodeClick() {},
    showPTV() {
      let ptvData2 = ptvData;
      let { RECORDS } = ptvData2;
      mapWork.processingData(RECORDS);
    },
    showPTV2() {
      mapWork.processingData2();
    },
  },
  mounted() {
    // this.init();
  },
  destroyed() {
    mapWork.init();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.head-operate > div {
  display: flex;
}
.upbtn {
  height: 26px;
  line-height: 26px;
  padding: 0 6px;
  border-color: rgba(42, 183, 255, 0.66) !important;
  background-color: rgba(42, 183, 255, 0.66) !important;
  color: rgba(255, 255, 255, 0.9) !important;
  &:hover {
    background-color: rgba(42, 183, 255, 0.9) !important;
  }
}
.el-upload__tip {
  color: rgba(255, 255, 255, 0.9) !important;
}
.el-scrollbar__bar.is-vertical {
  width: 6px;
  top: 2px;
}
.el-scrollbar__bar {
  position: absolute;
  right: 2px;
  bottom: 2px;
  z-index: 1;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 120ms ease-out;
}
.treeShape {
  background: none;
  @include elTreeNode2();
  max-height: initial;
  min-height: 100px;
}

.table {
  @include box_wh(320, 0);
  height: auto;
  // max-height: 500px;
  padding: 0;
  transition-property: max-height, width, overflow;
  transition-duration: 0.3s, 0.3s, 0.3s;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0 5px 0 0;
    font-size: 14px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
.head-operate {
  padding: 10px 10px;
  margin: 0 -5px !important;
  button {
    margin: 0 5px !important;
  }
}
/deep/ .el-tree-node__children .el-tree-node__content .el-checkbox {
  display: none;
}
</style>
